import { getToken } from "../auth/teamsAuth";

const GRAPH = "https://graph.microsoft.com/v1.0";

// ACHTUNG: <T> ist eine BEHAUPTUNG, keine Prüfung. Über die HTTP-Grenze
// kommt, was der Dienst schickt – nicht, was wir hier hinschreiben.
// Antwortformen deshalb nur aus der Graph-Referenz übernehmen und bei
// Abweichungen den Typ ändern, nicht die Stelle, die ihn benutzt.
export async function graphGet<T>(pfad: string, scopes: readonly string[]): Promise<T> {
  const MAX = 4;
  for (let versuch = 0; versuch < MAX; versuch++) {
    const token = await getToken(scopes);
    const antwort = await fetch(GRAPH + pfad, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Eine Drosselung ist KEIN Fehler. Planner begrenzt Anfragen und sagt
    // per Retry-After, wie lange zu warten ist – warten und wiederholen,
    // nichts verwerfen.
    if (antwort.status === 429 || antwort.status === 503) {
      const sekunden = Number(antwort.headers.get("Retry-After")) || 2 ** versuch;
      await new Promise((r) => setTimeout(r, sekunden * 1000));
      continue;
    }

    if (antwort.status === 403) {
      throw new Error(
        "Kein Zugriff. Dieses Board gehört zu einem Team, in dem du nicht Mitglied bist.",
      );
    }
    if (!antwort.ok) {
      throw new Error(`Graph antwortet mit ${antwort.status} auf ${pfad}`);
    }
    return (await antwort.json()) as T;
  }
  throw new Error(`Graph drosselt dauerhaft: ${pfad}`);
}
